// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LFWxa","type":"styles_type___0vET","choices":"styles_choices__2nNd5"};